import { render } from "./issue-tracker.vue?vue&type=template&id=46c8e303&scoped=true"
import script from "./issue-tracker.vue?vue&type=script&lang=ts"
export * from "./issue-tracker.vue?vue&type=script&lang=ts"

import "./issue-tracker.vue?vue&type=style&index=0&id=46c8e303&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46c8e303"

export default script